import moment from 'moment'
const ALIGN = 'center'
export const BASIC_DATA = [
  {
    title: '素材ID',
    key: 'id',
    type: 'basic',
    align: ALIGN,
    overflow: true,
    width: 110
  },
  {
    title: '素材',
    key: 'addr',
    width: 108,
    // overflow: true,
    type: 'basic'
  },
  {
    title: '媒体限制',
    key: 'excludeMediaNames',
    width: 120,
    overflow: false,
    type: 'basic'
  },
  {
    title: '内审拒绝理由',
    key: 'rejectReasonIdsName',
    type: 'basic',
    align: ALIGN,
    width: 160
  },

  {
    title: '内审详细描述',
    key: 'rejectDetailInfo',
    type: 'basic',
    align: ALIGN,
    width: 160
  },

  {
    title: '素材名称',
    key: 'imageName',
    type: 'basic',
    align: ALIGN,
    width: 160
  },
  {
    title: '母素材ID',
    key: 'imageId',
    type: 'basic',
    align: ALIGN,
    width: 80
  },

  {
    title: '关联计划数',
    key: 'planCount',
    type: 'basic',
    align: ALIGN,
    width: 90,
    formatter: ({ row }) => row.planCount || 0
  },
  {
    title: '头条评估标签',
    key: 'toutiaoLabelNames',
    type: 'basic',
    align: ALIGN,
    width: 110,
    formatter: ({ row }) => row.toutiaoLabelNames || '-'
  },
  {
    key: 'videoDesc',
    title: '视频描述',
    overflow: false,
    width: 220,
    type: 'basic',
    align: ALIGN
  },

  {
    key: 'videoClips',
    title: '片段描述',
    width: 220,
    type: 'basic',
    overflow: true
  },
  {
    key: 'aiLabelNames',
    title: 'AI标签',
    overflow: true,
    width: 120,
    type: 'basic'
  },
  {
    title: '关键词',
    key: 'keywords',
    type: 'basic',
    width: 120,
    overflow: true
  },
  {
    title: '尺寸',
    key: 'width',
    type: 'basic',
    overflow: true,
    width: 90,
    formatter: ({ row }) => `${row.width} x ${row.height}`
  },
  {
    title: '大小',
    key: 'size',
    type: 'basic',
    overflow: true,
    width: 100,
    formatter: ({ row }) => `${row.size ? (row.size / 1024 / 1024).toFixed(2) : 0}M`
  },
  {
    title: '设计人',
    key: 'designerName',
    type: 'basic',
    width: 86,
    overflow: true
  },
  {
    title: '策划人',
    key: 'plannerName',
    type: 'basic',
    width: 77,
    overflow: true
  },
  {
    title: '消耗起始时间',
    type: 'basic',
    key: 'lauchTime',
    width: 140,
    overflow: true,
    formatter: ({ row }) => moment(row.lauchTime).format('YYYY-MM-DD HH:mm:ss')
  },
  {
    title: '上传时间',
    key: 'createTime',
    type: 'basic',
    width: 140,
    overflow: true,
    formatter: ({ row }) => moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
  },

  {
    title: '营销主题标签',
    key: 'typeLabelNames',
    type: 'basic',
    width: 110,
    overflow: true
  },
  {
    title: '游戏',
    key: 'gameNames',
    type: 'basic',
    overflow: true,
    width: 70
  },
  {
    title: '3D视频源标签',
    key: 'videoLabelNames',
    type: 'basic',
    overflow: true,
    width: 110
  },
  {
    title: '内容标签',
    key: 'labelNames',
    type: 'basic',
    overflow: true,
    width: 90
  }
].map((i) => ({ ...i, checked: true }))

export default {
  BASIC_DATA
}

export const NAVS = [
  {
    label: '基础信息',
    key: '1',
    children: [
      {
        label: '基础信息',
        key: 'BASIC_DATA'
      }
    ]
  }
]
